import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __MessageTypes, __Deactivate, enum__DEACTIVATE } from '../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetBoarScope } from '../../../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import CTextBox from '../../../../Common/CTextBox';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { addBoardScope, addListBoardScopes, updateBoardScope } from '../../../../../services/sKPI/board.service';
import { getGridLocalization, isNullUndefinedOrEmpty, showMessage } from '../../../../../common/Helpers';
import { Dropdown, Toggle } from '@fluentui/react';
import { useDispatch, useSelector } from 'react-redux';
import { __Consolidation, enum__ConsolidationLeters } from '../../../../../common/Dictionaries';
import { action_setBoardScopeValues } from '../../../../../reducers/actions/KPI/actions';
import { useOfGetConsolidateionList } from '../../../../../hooks/services/sKPI/useOfBoard';

const SidePanelAddConsolidation = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { _boardScopeValues: objBoardScopeValues } = useSelector((state) => state.boardConsGroupScope);
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_BoardId = null,
    } = props;

    const gridRef = useRef();

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    //const [tglDeactivate, setTglDeactivate] = useState(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [isValidForm, setIsValidForm] = useState({
        name: true,
        scopeNemo: true,
        perspectiveId: true
    });
    
    const [objConsolidation, setObjConsolidation] = useState(__OBJECT_STRUCTURE_GetBoarScope())
    
    const [fireUpdate, setFireUpdate] = useState(null)
    const [objConsolidationList, setObjConsolidationList] = useState(null)
    useOfGetConsolidateionList(inputParam_BoardId, objConsolidationList, setObjConsolidationList, setFireUpdate, inputParam_IsPanelOpen)

    const validateForm = () => {
        let isValid =(
            objConsolidation.name !== null  &&
            objConsolidation.scopeCode !== null  &&
            objConsolidation.perspectiveId !== null
        ) ? true : false;

        isValidForm.name = !isNullUndefinedOrEmpty(objConsolidation.name)
        isValidForm.scopeCode = !isNullUndefinedOrEmpty(objConsolidation.scopeCode)
        isValidForm.perspectiveId = !isNullUndefinedOrEmpty(objConsolidation.perspectiveId)
        isValid = (isValidForm.name || isValidForm.scopeCode || isValidForm.perspectiveId);

        if (isValid) {
            isValidForm.name = isValid
            isValidForm.scopeCode = isValid
            isValidForm.perspectiveId = isValid
        }

        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)

        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });
        setObjConsolidation(__OBJECT_STRUCTURE_GetBoarScope(null));
        setObjConsolidationList(null);
        setFireUpdate(true);
    };

    const onAddItem = () => {
        let newobj = null

        newobj = JSON.parse(JSON.stringify(objConsolidation));
        newobj.id = 0;
        newobj.scopeNemo = '';
        newobj.scopeCode = objConsolidation.scopeCode;
        newobj.name = objConsolidation.name;
        newobj.perspectiveId = objConsolidation.perspectiveId;
        newobj.boardId = inputParam_BoardId;
        newobj.deactivate = objConsolidation.deactivate;
        newobj.visible = true;

        if (validateForm()) {
            addBoardScope(newobj).then((response) => {
                if (response.data.succeeded) {
                    objConsolidationList.push({
                        boardId: inputParam_BoardId,
                        deactivate: objConsolidation.deactivate,
                        id: response.data.data,
                        name: objConsolidation.name,
                        perspectiveCode: __Consolidation.find(x => x.id === objConsolidation.perspectiveId).key,
                        perspectiveId: objConsolidation.perspectiveId,
                        scopeCode: objConsolidation.scopeCode,
                        scopeNemo: objConsolidation.scopeNemo,
                        scopeValue: null,
                    })
                    setObjConsolidationList(objConsolidationList);
                    setFireUpdate(true);

                    setObjConsolidation(__OBJECT_STRUCTURE_GetBoarScope())

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    dispatch(action_setBoardScopeValues({objectList: objConsolidationList}));

                    if (gridRef.current) {
                        gridRef.current.updatebounddata('cells');
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
    };

    const onClean = () => {
        setObjConsolidation(__OBJECT_STRUCTURE_GetBoarScope())
    }

    const onAttachUnused = () => {
         if (validateForm()) {
            const selectedItems = gridRef.current.props.source.records.filter(x => x.belongsToBoard === true);

            addListBoardScopes(inputParam_BoardId, selectedItems).then((response) => {
                if (response.data.succeeded) {
                    setObjConsolidation(__OBJECT_STRUCTURE_GetBoarScope(null));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    dispatch(action_setBoardScopeValues({objectList: objConsolidationList}))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
    }

    const onEditItem = () => {
        let newobj = null

        newobj = JSON.parse(JSON.stringify(objConsolidation));
        newobj.boardId = inputParam_BoardId;
        newobj.scopeCode = objConsolidation.scopeCode;
        newobj.scopeNemo = '';
        newobj.name = objConsolidation.name;
        newobj.perspectiveId = objConsolidation.perspectiveId;
        newobj.deactivate = objConsolidation.deactivate;
        newobj.visible = true;

        if (validateForm()) {
            updateBoardScope(newobj.id, newobj).then((response) => {
                if (response.data.succeeded) {

                    let obj = objBoardScopeValues.find(x => x.id === newobj.id);
                    obj.boardId = newobj.boardId;
                    obj.name = newobj.name;
                    obj.perspectiveId = newobj.perspectiveId;
                    obj.perspectiveCode = __Consolidation.find(x => x.id === newobj.perspectiveId).key;
                    obj.deactivate = newobj.deactivate;
                    
                    setObjConsolidationList(objConsolidationList);
                    setFireUpdate(true);

                    setObjConsolidation(__OBJECT_STRUCTURE_GetBoarScope(null));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    dispatch(action_setBoardScopeValues({objectList: objConsolidationList}))

                    if (gridRef.current) {
                        gridRef.current.updatebounddata('cells');
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
    };

    const onEditItemOnList = (item) => {
        setObjConsolidation({
            id: item.id,
            scopeNemo: item.scopeNemo,
            scopeCode: item.scopeCode,
            name: item.name,
            perspectiveId: !isNullUndefinedOrEmpty(item.perspectiveId) ? item.perspectiveId : enum__ConsolidationLeters.Empty,
            deactivate: item.deactivate,
        });
    };

    const onDeactivateChange = (e, checked) => {
        //setTglDeactivate(checked);
    };

    const onChangePerspective = (ev, item) => {
        setObjConsolidation(prevState => ({
            ...prevState,
            perspectiveId: item.key
        }));
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const setterObjConsolidation = (controlValue, controlName) => {
        setObjConsolidation(prevState => ({
            ...prevState,
            [controlName.split('_')[1]]: controlValue
        }));
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            objConsolidation.id === 0 &&
                            <>
                                <PrimaryButton onClick={ onAttachUnused } styles={_global_buttonStyles}>{ t('data-lang-btn-attach') }</PrimaryButton>
                                <PrimaryButton onClick={ onAddItem } styles={_global_buttonStyles}>{ t('data-lang-btn-add') }</PrimaryButton>
                            </>
                        }
                        {
                            objConsolidation.id !== 0 &&
                            <>
                                <PrimaryButton onClick={ onAttachUnused } styles={_global_buttonStyles}>{ t('data-lang-btn-attach') }</PrimaryButton>
                                <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-edit') }</PrimaryButton>
                                <DefaultButton onClick={ onClean } className='me-2'>{ t('data-lang-btn-clean') }</DefaultButton>
                            </>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            default:
                break;
        }

        return className;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return objConsolidationList[rowIndex.boundindex].id;
        }
        return objConsolidationList[rowIndex]?.id;
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = objConsolidationList.find(x => x.id === itemId)

        return  <IconButton iconProps={{ iconName: 'Edit' }} title={t('data-lang-btn-edit')} ariaLabel={t('data-lang-btn-edit')} onClick={() => onEditItemOnList(item)} />
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'checkbox':
                editor.jqxCheckBox({ checked: (cellValue === 1 || cellValue === '1' || cellValue === 'True' || cellValue === 'true'), width: width });
                break;
            default:
                break;
        }
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-addconsolidation') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-5 d-none">
                    <Col className="col-auto ms-auto mt-auto col">
                        <Toggle
                            checked={ objConsolidation.deactivate === enum__DEACTIVATE.YES ? true : false }
                            onChange={ onDeactivateChange }
                            role="checkbox"
                            label={<div>{t('data-lang-lbl-deactivated')}</div>}
                            onText={t(__Deactivate.find(x => x.key === enum__DEACTIVATE.YES).value)}
                            offText={t(__Deactivate.find(x => x.key === enum__DEACTIVATE.NO).value)}
                            styles={ {root:{paddingTop: "14px", float: "right", display: "flex"}, label: {marginRight : "25px", padding: "0px, 10px"}} }
                        />
                    </Col>
                </Row>
                <Row className="pt-5">
                    <Col xl={6}>
                        <CTextBox
                            textBoxName={`txtName_name`}
                            labelText={t('data-lang-lbl-name')}
                            controlValue={objConsolidation.name}
                            setterControlValue={setterObjConsolidation}
                        />
                    </Col>
                    <Col xl={6}>
                        <div><b>{t('data-lang-lbl-perspective')}</b></div>
                        <Dropdown
                            placeholder={t('data-lang-placeholder-selectoption')}
                            options={ __Consolidation.map(({ id, text }) => {return {key: id, title: t(text), text: t(text) }}) }
                            selectedKey={objConsolidation !== null ? (objConsolidation.perspectiveId !== null ? objConsolidation.perspectiveId : null) : null}
                            styles={ {title: { height: "27px" }} }
                            errorMessage={objConsolidation === null ? t('data-lang-msg-required') : (objConsolidation.perspectiveId === null ? t('data-lang-msg-required') : undefined)}
                            required={true}                                           
                            onChange={ onChangePerspective }
                        />
                    </Col>
                </Row>
                <Row className="pt-5">
                    <Col>
                    {
                        objConsolidationList &&
                        <JqxGrid
                            ref={gridRef}
                            altrows={true}
                            enabletooltips={true}
                            width={'100%'}
                            theme={'light'} 
                            autoheight={true}
                            editable={true}
                            pageable={false}
                            sortable={false}
                            filterable={false}
                            showfilterrow={false} 
                            localization={getGridLocalization(t)}
                            source={ new jqx.dataAdapter({
                                localData: objConsolidationList,
                                dataType: 'array',
                                dataFields: [
                                    { name: 'id',              type: 'number' },
                                    { name: 'perspectiveId',   type: 'number' },
                                    { name: 'Perspective_Id',   value:'perspectiveId', values: { source: __Consolidation.map(x => {return { key: x.id, name: `${t(x.text)}` }}), value: 'key', name: 'name' } },
                                    { name: 'name',            type: 'string' },
                                    { name: 'deactivated',     type: 'bool'   },
                                    { name: 'belongsToBoard',  type: 'bool'   },
                                ],
                                id: 'id'
                            })}
                            columns={[
                                { index: null, text: 'ID',                           dataField: 'id',              uploadMasive: false, exportable: false, width: '0px', editable: false, hidden: true },
                                { index: null, text: t('data-lang-lbl-actions'),     dataField: 'acciones',        uploadMasive: false, exportable: false, width: '80px', pinned: true,
                                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                    initwidget:   (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                }, 
                                { index: null, text: t('data-lang-lbl-attached'),      dataField: 'belongsToBoard',  uploadMasive: false, exportable: false, width: '85px', pinned: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'), columntype: 'checkbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: true },
                                { index: 0,    text: t('data-lang-lbl-perspective'), dataField: 'perspectiveId',   uploadMasive: false, exportable: true,  width: '100px',  editable: false, columntype: 'dropdownlist',   displayfield: 'Perspective_Id' },
                                { index: 1,    text: t('data-lang-lbl-name'),        dataField: 'name',            uploadMasive: false, exportable: true,  editable: false, columntype: 'textbox'  },
                                { index: 2,    text: t('data-lang-lbl-deactivated'), dataField: 'deactivated',     uploadMasive: false, exportable: true,  width: '95px', editable: false, columntype: 'checkbox' },    
                            ]}
                        />
                    }
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelAddConsolidation.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_BoardId: PropTypes.number.isRequired,
};

export default SidePanelAddConsolidation;